var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import Box from '@mui/material/Box';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import ToggleButton from '@mui/material/ToggleButton';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useCallback, useId, useMemo } from 'react';
import each from 'lodash/forEach';
import Collapse from '@mui/material/Collapse';
import { useTranslation } from 'react-i18next';
import LinearProgress from '@mui/material/LinearProgress';
import { OGPseudoTable, OGPseudoTableBody, OGPseudoTableCell, OGPseudoTableRow } from '@opengear/table';
import { useTheme } from '@mui/material/styles';
import { useOpen } from '@/hooks/open';
import { createBarStyles, ExpandRowTableCell, NameCell, PermissionCell } from './utils';
export function GroupsAndRolesPermissionsSectionRow(_a) {
    var children = _a.children, permissions = _a.permissions, title = _a.title;
    var theme = useTheme();
    var t = useTranslation().t;
    var _b = useOpen(), open = _b.open, handleToggle = _b.handleToggle;
    var uuid = useId();
    var counts = useMemo(function () {
        var deny = 0;
        var readOnly = 0;
        var readWrite = 0;
        each(permissions, function (value) {
            if (value.overall === 'read_write') {
                readWrite += 1;
            }
            else if (value.overall === 'read_only') {
                readOnly += 1;
            }
            else if (value.overall === 'deny') {
                deny += 1;
            }
        });
        var total = deny + readOnly + readWrite;
        return {
            deny: deny,
            read_only: readOnly,
            read_write: readWrite,
            total: total,
        };
    }, [permissions]);
    var normalize = useCallback(function (value) { return (value * 100) / counts.total; }, [counts.total]);
    return (_jsxs(_Fragment, { children: [_jsxs(OGPseudoTableRow, __assign({ "aria-label": title }, { children: [_jsx(ExpandRowTableCell, { children: _jsx(ToggleButton, __assign({ "aria-controls": "permissions-section-content-".concat(uuid), "aria-expanded": open, "aria-labelledby": "permissions-section-title-".concat(uuid), onChange: handleToggle, sx: { padding: 0 }, selected: open, value: "check" }, { children: open ? _jsx(ExpandLessIcon, {}) : _jsx(ExpandMoreIcon, {}) })) }), _jsx(NameCell, __assign({ id: "permissions-section-title-".concat(uuid) }, { children: title })), _jsx(PermissionCell, { children: _jsxs(Box, { children: [_jsx(CheckCircleOutlineIcon, { color: "success", sx: { marginX: 'auto' } }), _jsx(LinearProgress, { "aria-label": t('components.permissions.table.headers.read_write'), "aria-valuemin": 0, "aria-valuemax": counts.total, "aria-valuenow": counts.read_write, color: "success", role: "meter", value: normalize(counts.read_write), variant: "determinate", sx: createBarStyles(theme) })] }) }), _jsx(PermissionCell, { children: _jsxs(Box, { children: [_jsx(VisibilityIcon, { color: "warning", sx: { marginX: 'auto' } }), _jsx(LinearProgress, { "aria-label": t('components.permissions.table.headers.read_only'), "aria-valuemin": 0, "aria-valuemax": counts.total, "aria-valuenow": counts.read_only, color: "warning", role: "meter", value: normalize(counts.read_only), variant: "determinate", sx: createBarStyles(theme) })] }) }), _jsx(PermissionCell, { children: _jsxs(Box, { children: [_jsx(DoDisturbIcon, { color: "error", sx: { marginX: 'auto' } }), _jsx(LinearProgress, { "aria-label": t('components.permissions.table.headers.deny'), "aria-valuemin": 0, "aria-valuemax": counts.total, "aria-valuenow": counts.deny, color: "error", role: "meter", value: normalize(counts.deny), variant: "determinate", sx: createBarStyles(theme) })] }) })] })), _jsx(OGPseudoTableRow, { children: _jsx(OGPseudoTableCell, __assign({ sx: { border: 'none', padding: 0, width: '100%' } }, { children: _jsx(Collapse, __assign({ in: open, sx: { width: '100%' }, unmountOnExit: true }, { children: _jsx(OGPseudoTable, __assign({ id: "permissions-section-content-".concat(uuid) }, { children: _jsx(OGPseudoTableBody, { children: children }) })) })) })) })] }));
}
